import React from "react"
import {Draggable, Droppable, DragDropContext} from "react-beautiful-dnd"
import "../accounts/accounts.css"
import ApiService from "../../../Services/ApiService";

/**
 * a little function to help us with reordering the result
 */
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

/**
 * Moves an item from one list to another list.
 */
const move = (source, destination, droppableSource, droppableDestination) => {
    const sourceClone = Array.from(source);
    const destClone = Array.from(destination);
    const [removed] = sourceClone.splice(droppableSource.index, 1);

    destClone.splice(droppableDestination.index, 0, removed);

    const result = {};
    result[droppableSource.droppableId] = sourceClone;
    result[droppableDestination.droppableId] = destClone;

    return result;
};

class JobFunctions extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            campaign_id: '',
            job_functions: [],
            job_ids: [],
            selected_job_ids: props.data
        };

        this.fetchJobFunctions()
    }

    // map of droppable id to the proper state's sub object
    id2List = {
        droppable1: 'job_ids',
        droppable2: 'selected_job_ids'
    };


    componentDidUpdate(prevProps, prevState, snapshot) {

        if (!this.arraysEqual(prevProps.data, this.props.data)) {
            this.setState({...this.state, selected_job_ids: this.props.data})
        }

    }


    fetchJobFunctions() {
        ApiService.get('/api/campaigns/fetch-job-functions').then(response => {
            let jobFunctions = response.data.job_functions;
            let jobFunctionIds = jobFunctions.map((jobFunction) => {
                return jobFunction.ID;
            });

            this.setState({
                ...this.state,
                job_functions: jobFunctions,
                job_ids: jobFunctionIds
            });
        });
    }

    getList = id => this.state[this.id2List[id]];

    onDragJobEnd = (result) => {
        const { destination, source } = result;

        // do nothing if the item is dragged into outside of the droppable
        if(!destination) {
            return
        }

        // do nothing if the item is not moved
        if(destination.droppableId === source.droppableId &&
            destination.index === source.index
        ) {
            return;
        }

        if (source.droppableId === destination.droppableId) {
            const items = reorder(
                this.getList(source.droppableId),
                source.index,
                destination.index
            );
            this.setState({ [this.id2List[source.droppableId]] : items},
                () => {
                    this.props.onJobFunctionsChange(this.state.selected_job_ids)
                });
        } else {
            const result = move(
                this.getList(source.droppableId),
                this.getList(destination.droppableId),
                source,
                destination
            );

            this.setState({
                job_ids: result.droppable1,
                selected_job_ids: result.droppable2
            }, () => { this.props.onJobFunctionsChange(this.state.selected_job_ids)});
        }
    };

    arraysEqual = (a1, a2)  =>  {
        return JSON.stringify(a1) === JSON.stringify(a2);
    };

    render() {
        if (this.state.job_functions.length) {
            return(
                <div className="jobs">
                    <DragDropContext onDragEnd={this.onDragJobEnd}>
                        {
                            Object.keys(this.id2List).map((keyName, keyIndex) => (
                                <Droppable droppableId={keyName} key={keyName}>
                                    {(provided) => (
                                        <div
                                            ref={provided.innerRef}
                                            className="all-jobs"
                                        >
                                            {
                                                this.state[this.id2List[keyName]].map((value, index) => (
                                                    <Draggable
                                                        key = {value}
                                                        draggableId={value}
                                                        index={index}
                                                    >
                                                        {(provided) => (
                                                            <span
                                                                ref={provided.innerRef}
                                                                {... provided.draggableProps}
                                                                {... provided.dragHandleProps}
                                                                className={"job-function " + this.id2List[keyName]}
                                                            >
                                                                {this.state.job_functions.find(job => job.ID === value).JobFunction}
                                                            </span>
                                                        )}
                                                    </Draggable>
                                                ))
                                            }
                                            {provided.placeholder}
                                        </div>
                                    )}
                                </Droppable>
                            ))
                        }
                    </DragDropContext>
                </div>
            )
        } else {
            return(<div></div>);
        }

    }
}

export default JobFunctions